import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { tipsArticle } from '@/mocks/articleData';

export default function TipsArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={tipsArticle} />
      <Footer />
    </>
  );
}